import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cef2d92c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=cef2d92c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef2d92c",
  null
  
)

component.options.__file = "index.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Selectorg/index.vue
// module id = null
// module chunks = 